import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useCommCounts(entityType, entityId) {
  const [counts, setCounts] = useState(null);
  const token = localStorage.getItem("ic_token");

  const refresh = useCallback(async () => {
    if (!token || !entityType || !entityId) return;
    try {
      const res = await axios.get(`${API}/comm/entity/${entityType}/${entityId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCounts(res.data?.counts || null);
    } catch { /* silent */ }
  }, [token, entityType, entityId]);

  useEffect(() => { refresh(); }, [refresh]);

  return { counts, refresh };
}

export function useMyRequestCounts() {
  const [openCount, setOpenCount] = useState(0);
  const token = localStorage.getItem("ic_token");

  const refresh = useCallback(async () => {
    if (!token) return;
    try {
      const res = await axios.get(`${API}/comm/requests?status=open`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOpenCount(res.data?.requests?.length || 0);
    } catch { /* silent */ }
  }, [token]);

  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => {
    const interval = setInterval(refresh, 30000);
    return () => clearInterval(interval);
  }, [refresh]);

  return { openCount, refresh };
}
